
import { Contact } from './Contact';
export class ContactDetails {
  public ContractNumber: string;
  public Contacts: Contact[];
}



// WEBPACK FOOTER //
// ./src/app/models/ContactDetails.ts